import { is } from 'ramda'
import i18n from 'i18next'

export const EMPTY_USER_CONDITION_OPTION_ID = '__EMPTY_USER_CONDITION__'

export const formatConditionValue = condition => {
  const value = condition.value
  const field = condition?.field || ''

  if (value === null && field.endsWith('user_id')) {
    return i18n.t('conditions.emptyUser', { ns: 'common' })
  }

  let label = value?.label || value?.name || value
  if (is(Array, value)) label = value?.map(item => item.label || item.name || item).join(', ')
  if (!label) label = '_________'

  return label
}
